export default "__VITE_ASSET__$RmRWdvr__"